export const ROUTE_ENDPOINTS = {
  LANDING: "/",
  HOME: "/home/*",
  GAME: "/game",
  GAME_FINISHED: "/game_finished",
  HOME_PLAY: "/home/play",
  HOME_DASHBOARD: "/home/dashboard",
  DASHBOARD: "/dashboard",
  PLAY: "/play",
};

export const ROUTE_NEW = "new";
